"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.CalendarDayDefaultProps = exports.CalendarDay = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _calendar = require("./calendar");

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

var CalendarDay = function CalendarDay(props) {
  var classNames = props.classNames,
      inCurrentMonth = props.inCurrentMonth,
      inHover = props.inHover,
      selected = props.selected,
      onClick = props.onClick,
      onMouseOver = props.onMouseOver,
      onMouseOut = props.onMouseOut,
      onFocus = props.onFocus,
      onBlur = props.onBlur,
      date = props.date,
      disabled = props.disabled;
  var dayContainerClassNames = (0, _classnames.default)(_defineProperty({
    'calendar-component__day': true,
    'calendar-component__day__disabled': disabled,
    'calendar-component__date__itementry': true
  }, "calendar-component__day__range-".concat(props.partofrange), props.partofrange !== false), classNames);
  var dayClassNames = (0, _classnames.default)({
    'calendar-component__date__itementry-fg': true,
    // shared with header item.
    'calendar-component__date__itementry-fg--currentmonth': inCurrentMonth,
    'calendar-component__date__itementry-fg--selected': selected,
    'calendar-component__date__itementry-fg--hover': inHover
  });

  var _onClick = function _onClick(event) {
    if (onClick && !disabled) {
      onClick(event, date);
    }
  };

  var _onMouseOver = function _onMouseOver(event) {
    if (onMouseOver && !disabled) {
      onMouseOver(event, date);
    }
  };

  var _onMouseOut = function _onMouseOut(event) {
    if (onMouseOut && !disabled) {
      onMouseOut(event, date);
    }
  };

  var _onFocus = function _onFocus(event) {
    if (onFocus && !disabled) {
      onFocus(event, date);
    }
  };

  var _onBlur = function _onBlur(event) {
    if (onBlur && !disabled) {
      onBlur(event, date);
    }
  }; // ADA compliant - allow an enter key to select instead of requiring click.


  var _handleKeyPress = function _handleKeyPress(target) {
    if (target.key === 'Enter' && !disabled) {
      target.currentTarget.click();
    }
  };

  return /*#__PURE__*/_react.default.createElement("div", {
    className: dayContainerClassNames,
    onClick: _onClick,
    onMouseOver: _onMouseOver,
    onMouseOut: _onMouseOut,
    onFocus: _onFocus,
    onBlur: _onBlur,
    onKeyDown: _handleKeyPress,
    tabIndex: 0,
    title: "".concat(_calendar.monthNames[date.getMonth()], " ").concat(date.getDate(), ", ").concat(date.getFullYear()),
    role: "button"
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: dayClassNames,
    tabIndex: -1
  }, date.getDate()));
};

exports.CalendarDay = CalendarDay;
CalendarDay.propTypes = {
  classNames: _propTypes.default.any.isRequired,
  disabled: _propTypes.default.bool.isRequired,
  date: _propTypes.default.instanceOf(Date).isRequired,
  inCurrentMonth: _propTypes.default.bool.isRequired,
  inHover: _propTypes.default.bool.isRequired,
  onClick: _propTypes.default.func.isRequired,
  onMouseOver: _propTypes.default.func.isRequired,
  onMouseOut: _propTypes.default.func.isRequired,
  onFocus: _propTypes.default.func.isRequired,
  onBlur: _propTypes.default.func.isRequired,
  selected: _propTypes.default.bool.isRequired,
  partofrange: _propTypes.default.oneOf([false, 'middle', 'start', 'end']).isRequired
};
var CalendarDayDefaultProps = {
  classNames: '',
  disabled: false
};
exports.CalendarDayDefaultProps = CalendarDayDefaultProps;
CalendarDay.defaultProps = CalendarDayDefaultProps;
var _default = CalendarDay;
exports.default = _default;